import React from 'react'
import { Link } from '@fs/zion-router'
import { css } from '@emotion/core'
import PropTypes from 'prop-types'
import { Skeleton } from '@fs/zion-ui'

const breadcrumbsCss = css`
  display: flex;
  flex-wrap: wrap;
`

const breadcrumbCss = css`
  display: flex;
  white-space: nowrap;
  height: 16px;
  font-size: 12px;
  line-height: 12px;
  padding-bottom: 4px;
  min-width: 36px;
  flex: 0 1 auto;
`

const arrowCss = css`
  padding: 0 8px;
`

const crumbTextCss = css`
  white-space: nowrap;
`
export default function Breadcrumbs({ breadcrumbs, loading }) {
  return loading ? (
    <Skeleton.Paragraph size="xs" />
  ) : (
    <div css={breadcrumbsCss}>
      {breadcrumbs?.map(({ to = '#', ...crumb }, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} css={breadcrumbCss}>
            <div css={crumbTextCss}>
              {index === breadcrumbs.length - 1 ? (
                crumb.text
              ) : (
                <Link wayfinding to={to} {...crumb}>
                  {crumb.text}
                </Link>
              )}
            </div>
            {index < breadcrumbs.length - 1 && (
              <span css={arrowCss} aria-hidden>
                &rsaquo;
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}

Breadcrumbs.propTypes = {
  /** The list of breadcrumbs to show. Objects passed to the Link component. Text prop for children. */
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      /** Text for the breadcrumb */
      text: PropTypes.string,

      /** Path to the route. Example: to="/frontier/app/react". See https://reacttraining.com/react-router/web/api/Link for all options. */
      to: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),

      /** For using Link outside of the Router. This prop is not needed for full urls. */
      external: PropTypes.bool,

      /** Action you'd like to see for this link on the analytics dashboard */
      action: PropTypes.string,

      /** If specified, and analytics is enabled for the react app, then analytics click metrics will be sent. The metrics will contain the specified value, which will be available in analytics reports.  */
      linkName: PropTypes.string,

      /** Optional way to also add an onclick to your link */
      onClick: PropTypes.func,

      /** If true this will prevent the page from scrolling to the top when clicked. Only works on internal links. */
      noScrollTop: PropTypes.bool,
    })
  ),
}
